import React from 'react';

import tick from '../assets/tick.svg';
import cross from '../assets/cross.svg';

const ModuleCheckbox = ({ label, active, status, moduleId }) => {

  let icon;
  if (status === 'passed') {
      icon = tick;
  } else if (status === 'failed') {
      icon = cross;
  } else {
      icon = null;
  }

  let statusText;
  switch (status) {
    case 'passed':
        statusText = 'Passed';
        break;
    case 'failed':
        statusText = 'Failed';
        break;
    case 'submitted':
        statusText = 'Submitted';
        break;
    default:
      statusText = 'Not submitted';
}

  return (
    <div className={`${active ? 'bg-white p-6' : 'px-6 p-3'}`}>
      <div className="flex items-center">
        {status && (
          <div className={`flex flex-none items-center justify-center text-center w-8 h-8 mr-6 border border-brandMidBlue ${status == 'passed' ? 'bg-brandMidBlue' : 'bg-white'}`}>
            {icon && <img src={icon} height={20} className="" alt="status icon" />}
          </div>
        )}
        <div className={`text-brandMidBlue text-sm pr-6 mb-1 mr-auto ${active ? 'font-bold' : ''}`}>
          {label}
        </div>
        {status && (
          <span className="text-brandMidBlue text-xs text-right text-gray-500 my-1 whitespace-nowrap">{statusText}</span>
        )}
      </div>
    </div>
  );
}

export default ModuleCheckbox;